import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';

import AppRoutes from './components/Routes/AppRoutes';
import LogIn from './pages/Auth/login';
import Invitation from './pages/Invitation/Invitation';
import { isAuthenticated } from './utilities/authentication';

   
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public invitation route (accessible without auth) */}
          <Route path='/invite/:token' element={<Invitation />} />
          
          {isAuthenticated() ? (
            <>
              <Route path='/*' element={<AppRoutes />} />
            </>
          )
            :
            <>
              <Route path='/' element={<LogIn />} />
              <Route path='*' element={<LogIn />} />
            </>
          }
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
